export const filterViewType = {
    round: "round",
    icon: "icon",
    button: "button",
    button_big: "button_big",
    range: "range",
    range_pips: "range_pips",
    checkbox: "checkbox",
    select: "select",
};

export const validFileExtensions = {
    image: ["image/jpg", "image/jpeg", "image/png"] as string[],
} as const;

export const passwordRegexp = /^.{8,}$/;

export const paymentMethods = {
    card: "card",
    paypal: "paypal",
    paypal_express: "paypal_express",
    affirm: "affirm",
    stripe: "stripe",
    affirm_express: "affirm_express",
    googlePay: "google_pay",
    applePay: "apple_pay",
    paytomorrow: "paytomorrow",
    klarna: "klarna",
    amazon_pay: "amazon_pay",
};

export const CACHE_API_ENDPOINTS = {
    bootstrap: "system_settings",
    "system-catalog": "product",
    products: "product",
    collections: "collection",
    pages: "page",
    articles: "posts",
    blog: "posts",
    posts: "posts",
    "system-entities": "page",
    blocks: "page",
    catalog: "product",
    filters: "product",
    popups: "page",
    "product-configurations": "product",
    "campaign-discount": "page",
    "payment-gateways": "payment_gateways",
    "payment-methods": "payment_methods",
} as const;

export const EVENTS_ID = {
    VISIT: "visit",
    ADD_TO_CART: "add_to_cart",
    REMOVE_FROM_CART: "remove_from_cart",
    BEGIN_CHECKOUT: "begin_checkout",
    ADD_PAYMENT_INFO: "add_payment_info",
    ADD_SHIPPING_INFO: "add_shipping_info",
    CHECKOUT_ERROR: "checkout_error",
    PURCHASE: "purchase",
    SEARCH: "search",
    ADD_TO_FAVORITES: "add_to_favorites",
    REMOVE_FROM_FAVORITES: "remove_from_favorites",
    REMAIN: "remain",
};
